<template>
  <section>
    <TableListing :items="items" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <template v-slot:cell(totalBaseFreight)="data">
        <span>$ {{ parseFloat(data.item.totalBaseFreight).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(totalFuelSurcharge)="data">
        <span>$ {{ parseFloat(data.item.totalFuelSurcharge).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(totalAcclSurcharge)="data">
        <span>$ {{ parseFloat(data.item.totalAcclSurcharge).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(totalTransportationCharged)="data">
        <span>$ {{ parseFloat(data.item.totalTransportationCharged).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(transportationMargin)="data">
        <span>$ {{ parseFloat(data.item.transportationMargin).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(transportationCarrierFees)="data">
        <span class="text-danger">$ {{ parseFloat(data.item.transportationCarrierFees).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(totalOtherRevenue)="data">
        <span>$ {{ parseFloat(data.item.totalOtherRevenue).toFixed(2) }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderedStorefrontItemsReport-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: '',
        sortDesc: false,
        perPage: 10,
        page: 1
      },
      tableOptions: {
        totalRows: 10,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'orderNumber', label: 'Ref #', sortable: true },
        { key: 'totalBaseFreight', label: 'Base Freight', sortable: true },
        { key: 'totalFuelSurcharge', label: 'Fuel Surcharge', sortable: true },
        { key: 'totalAcclSurcharge', label: 'Accl Surcharge', sortable: true },
        { key: 'totalTransportationCharged', label: 'Total Transp. Charged', sortable: true },
        { key: 'transportationCarrierFees', label: 'Carrier Fees', sortable: true },
        { key: 'transportationMargin', label: 'Margin', sortable: true },
        { key: 'totalOtherRevenue', label: 'Other Revenue', sortable: true }
      ],
    }
  }
}
</script>

<style>

</style>
